export const LANDING_URL = "https://me99office.vip/RFLANDINGPAAGE";
